import Vue from 'vue'
import Pc from './Pc.vue'
import router from './router'
import store from '../store/index'
// swiper相关
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)
// 引入公共样式
import '../assets/css/base.css'
// 引入公共js方法
import { util } from '../assets/js/util'
Vue.prototype.util = util
// 引入封装过的aixos请求
import Api from '../api/index'
Vue.use(Api)
import axios from 'axios'
Vue.prototype.axios = axios
import QRCode from 'qrcode'
window.QRCode = QRCode

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(Pc),
}).$mount('#app')
